/* Tiloa — offre quantité (bundle).
   - Relie les cartes au champ « quantity » du formulaire produit Shopify existant.
   - Calcule les prix à partir du prix réel de la variante, avec le format monétaire de la boutique.
   - Suit les changements de variante (événement Dawn « variant-change »).
   - Émet « tiloa:bundle-change » (document) pour la barre d'achat et la mesure. */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount}} €';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = fmt.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function decodeFormat(str) {
    var el = document.createElement('textarea');
    el.innerHTML = str || '';
    return el.value;
  }

  function init(root) {
    if (!root || root.dataset.bundleReady === 'true') return;
    root.dataset.bundleReady = 'true';

    var tiers;
    try { tiers = JSON.parse(root.querySelector('[data-bundle-tiers]').textContent); } catch (e) { return; }
    var format = decodeFormat(root.getAttribute('data-money-format'));
    var price = parseInt(root.getAttribute('data-price'), 10) || 0;
    var qtyInput = root.querySelector('[data-bundle-quantity]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-card]'));
    var form = document.getElementById(root.getAttribute('data-form-id'));
    // Libellé du bouton d'achat. Une fiche peut imposer sa propre formule via
    // data-atc-label ; sinon le bouton annonce le montant exact. Dès qu'il y a
    // plusieurs exemplaires, le total reprend la main : c'est l'information la
    // plus utile a ce moment-la.
    var labelImpose = root.getAttribute('data-atc-label');
    function libelleAchat(qty, total, format, defaut) {
      if (!total) return defaut;
      if (labelImpose && qty === 1) return labelImpose;
      return 'Ajouter au panier — ' + formatMoney(total, format);
    }
    var atcLabel = form && form.querySelector('[type="submit"][name="add"] > span');
    var atcDefault = atcLabel ? atcLabel.textContent.trim() : '';
    var unitOne = root.getAttribute('data-unit-one') || '';
    var unitPrefix = root.getAttribute('data-unit-prefix') || '';
    var unitSuffix = root.getAttribute('data-unit-suffix') || '';
    if (!unitPrefix && !unitSuffix) unitSuffix = ' / ' + unitOne;
    var addingLabel = root.getAttribute('data-adding-label') || 'Ajout…';
    var addedLabel = root.getAttribute('data-added-label') || 'Ajouté ✓';
    var live = root.querySelector('[data-bundle-live]');
    var savingPrefix = root.getAttribute('data-saving-prefix') || '';
    var savingSuffix = root.getAttribute('data-saving-suffix') || '';
    if (!savingPrefix && !savingSuffix) savingSuffix = ' de remise en plus';

    // Un éventuel sélecteur de quantité natif ferait doublon : on le neutralise.
    var formId = root.getAttribute('data-form-id');
    document.querySelectorAll('input[name="quantity"][form="' + formId + '"]').forEach(function (input) {
      if (input !== qtyInput) {
        input.removeAttribute('name');
        var wrapper = input.closest('.product-form__quantity');
        if (wrapper) wrapper.hidden = true;
      }
    });

    function tierFor(qty) {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].qty === qty) return tiers[i];
      return tiers[0];
    }

    function compute(qty) {
      var tier = tierFor(qty);
      var pct = tier.pct || 0;
      var full = price * qty;
      // Shopify applique la remise a l'unite et arrondit le centime a
      // l'inferieur, puis multiplie par la quantite. Calculer sur le total
      // donne un resultat different des que le pourcentage tombe sur une
      // demi-centime : a 39,95 EUR, le palier -30 % affichait 83,89 EUR pour
      // 83,91 EUR reellement factures. Le prix annonce doit etre le prix paye.
      // Remise fixe : c'est le montant exact de la remise automatique Shopify,
      // soustrait tel quel (offres a prix rond, par exemple 63,95 EUR).
      var montant = tier.amount || 0;
      if (montant > 0) {
        var totalFixe = full - montant;
        return { qty: qty, pct: 0, montantFixe: montant, title: tier.title, full: full, saving: montant, total: totalFixe, unit: Math.round(totalFixe / qty) };
      }
      var saving = Math.floor(price * pct / 100) * qty;
      return { qty: qty, pct: pct, montantFixe: 0, title: tier.title, full: full, saving: saving, total: full - saving, unit: price - Math.floor(price * pct / 100) };
    }

    function renderPrices() {
      cards.forEach(function (card) {
        var c = compute(parseInt(card.getAttribute('data-qty'), 10));
        var totalEl = card.querySelector('[data-bundle-total]');
        var savingEl = card.querySelector('[data-bundle-saving]');
        var unitEl = card.querySelector('[data-bundle-unit]');
        if (totalEl) totalEl.textContent = formatMoney(c.total, format);
        if (savingEl) savingEl.textContent = savingPrefix + formatMoney(c.saving, format) + savingSuffix;
        var wasEl = card.querySelector('[data-bundle-was-amount]');
        if (wasEl) wasEl.textContent = formatMoney(c.full, format);
        if (unitEl) unitEl.textContent = unitPrefix + formatMoney(c.unit, format) + unitSuffix;
      });
    }

    function select(qty, silent) {
      var c = compute(qty);
      qtyInput.value = String(qty);
      cards.forEach(function (card) {
        var on = parseInt(card.getAttribute('data-qty'), 10) === qty;
        card.classList.toggle('is-selected', on);
        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = on;
        if (on && !silent) {
          card.classList.remove('is-bumping');
          void card.offsetWidth;
          card.classList.add('is-bumping');
        }
      });
      // Plus de récapitulatif sous les offres : chaque carte affiche déjà son
      // total, son économie réelle et son prix par unité.
      // Le bouton annonce le montant exact qui sera ajouté : c'est la dernière
      // information que le visiteur lit avant de cliquer.
      var boutonAchat = form && form.querySelector('[type="submit"][name="add"]');
      if (atcLabel && !atcLabel.dataset.busy && !(boutonAchat && boutonAchat.hasAttribute('disabled'))) {
        atcLabel.textContent = libelleAchat(qty, c.total, format, atcDefault);
      }
      root.dataset.selectedQty = String(qty);
      document.dispatchEvent(new CustomEvent('tiloa:bundle-change', {
        detail: {
          sectionId: root.getAttribute('data-section-id'),
          quantity: qty,
          percentage: c.pct,
          total: c.total,
          compareAt: c.full,
          saving: c.saving,
          totalFormatted: formatMoney(c.total, format),
          label: c.saving > 0 ? c.title + ' · −' + formatMoney(c.saving, format) : c.title
        }
      }));
    }

    cards.forEach(function (card) {
      var radio = card.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) select(parseInt(card.getAttribute('data-qty'), 10));
        });
      }
    });

    // Changement de variante : nouveau prix, même quantité.
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant || !document.body.contains(root)) return;
        price = variant.price;
        // Vignettes des offres : image de la couleur choisie (sans vignette fixe).
        var media = variant.featured_media && variant.featured_media.preview_image;
        if (root.hasAttribute('data-thumb-variant') && media && media.src) {
          var base = media.src + (media.src.indexOf('?') > -1 ? '&' : '?');
          root.querySelectorAll('.tiloa-bundle__thumb img').forEach(function (img) {
            img.src = base + 'width=120';
            img.srcset = base + 'width=60 60w, ' + base + 'width=120 120w';
          });
        }
        renderPrices();
        select(parseInt(root.dataset.selectedQty || qtyInput.value, 10) || 1, true);
      });
    }

    // Retour visuel pendant l'ajout au panier.
    if (form && atcLabel) {
      form.addEventListener('submit', function () {
        atcLabel.dataset.busy = 'true';
        atcLabel.textContent = addingLabel;
        if (live) live.textContent = '';
        form.querySelector('[type="submit"][name="add"]').classList.add('is-adding');
      });
      var confirmTimer = null;
      var reset = function () {
        delete atcLabel.dataset.busy;
        var qty = parseInt(qtyInput.value, 10) || 1;
        atcLabel.textContent = libelleAchat(qty, compute(qty).total, format, atcDefault);
        var btn = form.querySelector('[type="submit"][name="add"]');
        if (btn) btn.classList.remove('is-adding', 'is-added');
      };
      // Confirmation brève « Ajouté ✓ » avant de revenir au libellé courant.
      var restore = function () {
        if (!atcLabel.dataset.busy) return;
        var btn = form.querySelector('[type="submit"][name="add"]');
        atcLabel.textContent = addedLabel;
        if (live) live.textContent = addedLabel.replace(/\s*✓\s*$/, '') || 'Ajouté au panier';
        if (btn) {
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
        }
        clearTimeout(confirmTimer);
        confirmTimer = setTimeout(reset, 1400);
      };
      if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        window.subscribe(PUB_SUB_EVENTS.cartUpdate, restore);
      }
      setInterval(function () { if (atcLabel.dataset.busy && !document.querySelector('.product-form__submit.loading')) restore(); }, 1500);
    }

    renderPrices();
    select(parseInt(qtyInput.value, 10) || 1, true);
  }

  function initAll() {
    document.querySelectorAll('[data-tiloa-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Le thème peut remplacer le bloc produit lors d'un changement de variante : on réinitialise.
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; initAll(); }, 120);
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', initAll);
})();
